import React from 'react';
import { Icon } from './Icon.js';
export const IconCodeMergeFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M11,11.75c-3.032,0-5.5-2.467-5.5-5.5,0-.414-.336-.75-.75-.75s-.75,.336-.75,.75v10c0,.414,.336,.75,.75,.75s.75-.336,.75-.75v-5.684c1.283,1.631,3.269,2.684,5.5,2.684,.414,0,.75-.336,.75-.75s-.336-.75-.75-.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "4.75", cy: "4", r: "2.75", fill: "currentColor" }),
        React.createElement("circle", { cx: "13.25", cy: "12.5", r: "2.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconCodeMergeFill18.js.map